import type { ShellLayout } from '../../../_components/Shell.js';
import type { Attachment } from '../types.js';

export function resolveLayoutMode(layoutMode: string | undefined): ShellLayout {
  if (layoutMode === 'drawer-right' || layoutMode === 'drawer-left') return layoutMode;
  return 'modal';
}

export function defaultAttachmentFilename(attachment: Attachment): string {
  const timestamp = Date.now();
  if (attachment.kind === 'recording') return `recording-${timestamp}.webm`;
  if (attachment.kind === 'screenshot') return `screenshot-${timestamp}.png`;
  return `attachment-${timestamp}`;
}
